import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import "@arco-design/web-react/dist/css/arco.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);
